export default {
    GET_STATS: "GET_STATS"
}